// extracted by mini-css-extract-plugin
export default {"collaborator-select":"hCDtPaiIg9","collaboratorSelect":"hCDtPaiIg9"};